module.exports = __webpack_public_path__ + "img/girl panique.0adbbbe8.png";